import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.478 10 10" opacity=".4" /><path d="M15.86 8.705l-1.62 5.12c-.06.21-.23.38-.44.44l-5.1 1.6a.448.448 0 01-.56-.56l1.6-5.13c.06-.21.23-.37.44-.44l5.12-1.6c.35-.11.67.22.56.57" /></svg>;